<div class="loader">
  <p-progressSpinner animationDuration="1.2s"></p-progressSpinner>
</div>
